import React, { useCallback } from 'react'
import { UserResponse } from 'api/Identity/Types/UserResponse'
import { Loading } from 'components/Loading'
import { useApiClient } from 'utils/api/ApiClient'
import { IdentityApiClient } from 'utils/api/identityApi'
import { useFetchOne } from 'utils/api/useFetch'

import AddEditUserStatisticsForm from './AddEditUserStatisticsForm'

interface OuterProps {
  user: UserResponse
}

export const AddEditUserStatisticsPage: React.FC<OuterProps> = ({ user }) => {
  const identityApiClient = useApiClient(IdentityApiClient)
  const fetchData = useCallback(
    () => identityApiClient.getAdministrationUserStatistics(user.id),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [user]
  )
  const { data: statistics, isLoading: isLoadingStatistics } = useFetchOne(fetchData)

  const fetchActivityCallback = useCallback(
    async () => identityApiClient.getAdministrationUserActivity(user.id),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [user]
  )
  const { data: userActivity, isLoading: isLoadingActivity } = useFetchOne(fetchActivityCallback)

  return (
    <Loading isLoading={isLoadingStatistics || isLoadingActivity} modalView={true}>
      <AddEditUserStatisticsForm statistics={statistics} userActivity={userActivity} />
    </Loading>
  )
}
